import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  mutation AddOrdersToWave($input: AddOrdersToWaveInput!) {
    addOrdersToWave(input: $input) {
      orders {
        ...OrderRow
      }
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/addOrdersToWave.js